<nav #navbar class="navbar active">
    <div class="container-fluid">
        <div class="navbar-header">
            <a href="#" onClick="return false;" class="navbar-toggle collapsed" (click)="isNavbarCollapsed = !isNavbarCollapsed" aria-expanded="false"></a>
            <a href="#" onClick="return false;" class="bars" (click)="mobileMenuSidebarOpen($event,'overlay-open')"></a>
            <a class="navbar-brand" routerLink={{homePage}}>
                <!-- <img src="assets/images/mm_portal_sidebar_logo.png" alt="" /> -->
                <img src="assets/images/emblem-dark.png" width="40" height="52" alt="" />
                <!-- <span class="logo-name" style="font-size: 20px;">MyClick</span> -->
            </a>
        </div>
        <div class="collapse navbar-collapse" [ngbCollapse]="isNavbarCollapsed">
            <ul class="pull-left collapse-menu-icon">
                <li>
                    <button mat-icon-button (click)="callSidemenuCollapse()" class="sidemenu-collapse">
                        <mat-icon>menu</mat-icon>
                    </button>
                </li>
            </ul>
            <ul class="nav navbar-nav navbar-right">
                <!-- <li class="li-padding" *ngIf="isBirthdayToday">
                    <div class="text-center" style="line-height: 0px;">
                        <marquee direction="left" style="width:450px;height:25px;line-height:25px;font-weight:400; color: #737373" scrolldelay="200" behavior="loop">
                            <i class="fa fa-birthday-cake" style="color:chocolate;"></i> Many Many Happy Returns Of The Day...
                        </marquee>
                    </div>
                </li> -->
                <li class="li-padding" style="right: 50%;">
                    <!-- <h5 style="font-weight: 400;">Social Justice & Special Assistance Department</h5> -->
                    <h5>{{organization_name}}</h5>
                </li>
                <!-- <li class="li-padding" *ngIf="current_academic_year!=''">
                    <div class="text-center" style="line-height: 0px;">
                        <div class="badge col-red" style="font-size: 12px;">AY: {{current_academic_year}}</div>
                    </div>
                </li> -->
                <li class="li-padding">
                    <div class="text-center" style="line-height: 0px;">
                        <div class="badge col-green" style="font-size: 12px;">
                            <span *ngIf="role_id == 1">{{profile_name}} ( {{role_name}} )</span>
                            <span *ngIf="role_id != 1">{{profile_name}} ( {{taluka_name}} )</span>
                        </div>
                    </div>
                </li>

                <!-- Full Screen Button -->
                <!-- <li class="fullscreen">
                    <button mat-icon-button (click)="callFullscreen()" class=" nav-notification-icons">
            <mat-icon>fullscreen</mat-icon>
          </button>
                </li> -->
                <!-- #END# Full Screen Button -->
                <!-- #START# Notifications-->
                <!-- <li *ngIf="allAcademicYears.length>0">
                    <div class="form-group aligned-form">
                        <select class="form-control">
                        <option *ngFor="let year of allAcademicYears" [selected]="year.is_active==1" [disabled]="year.is_active==0">{{year.academic_year}}</option>
                    </select>
                    </div>
                </li> -->
                <!-- <li class="nav-item" ngbDropdown>
                    <button mat-icon-button ngbDropdownToggle class="nav-notification-icons">
                        <mat-icon>notifications_none</mat-icon>
                        <span *ngFor="let notification of this.notification" ng-hide="this.notification.length==0"
                            class="label-count bg-orange"></span>
                    </button>
                    <div ngbDropdownMenu class="notification-dropdown pullDown">
                        <div class="noti-list" style="position: relative; max-width: 600px; max-height: 250px;" [perfectScrollbar]>
                            <ul class="menu" style="max-height:250px; overflow-y: auto;">
                                <li>
                                    <a href="javascript:void(0);" *ngFor="let notification of notificationimageUrl" (click)="readNotification(notification.id)">
                                        <span class="table-img msg-user" *ngIf="notification.profileImageUrl!=null && notification.profileImageUrl!=''">
                                            <img src="{{notification.profileImageUrl}}" alt="">
                                        </span>
                                        <div class="menu-info">
                                            <p class="menu-title">{{notification.first_name}} {{notification.last_name}}
                                            </p>
                                            <p class="menu-desc" style="padding-top: 10px;">
                                                <span><i class="material-icons">access_time</i>
                                                    {{notification.notification_sent_date | date:'dd-MM-YYYY h:MM'}} </span><span style="padding-left: 100px;" *ngIf="notification.link!='' && notification.link!=null">
                                                        <td><i class="material-icons" title='Details'>info</i></td>
                                                    </span>
                                            </p>

                                            <p class="menu-desc" style="padding-top: 5px;">{{notification.notification_header}}</p>

                                        </div>
                                    </a>

                                </li>
                            </ul>
                        </div>
                        <div class="text-center d-block border-top py-1">
                            <a href="javascript:void(0);" (click)="readeAllNotification()">Read All Notifications</a> |
                            <a href="javascript:void(0);" (click)="viewAllNotification()">View All Notifications</a>
                        </div>

                    </div>
                </li> -->
                <!-- #END# Notifications-->
                <li class="nav-item user_profile" ngbDropdown>
                    <a href="#" onClick="return false;" ngbDropdownToggle role="button" class="nav-notification-icons pt-0">
                        <img src='../../../assets/images/admin.png' class="rounded-circle" width="32" height="32" alt="User">
                    </a>

                    <div ngbDropdownMenu class="notification-dropdown pullDown">
                        <div class="noti-list" style="position: relative; max-width: 600px; max-height: 300px;" [perfectScrollbar]>
                            <ul class="menu">
                                <li class="body">
                                    <ul class="user_dw_menu">
                                        <li (click)="goToProfile()">
                                            <a>
                                                <mat-icon aria-hidden="false" class="mr-2">person</mat-icon>Profile
                                            </a>
                                        </li>
                                        <!-- <li>
                                            <a href="#" onClick="return false;">
                                                <mat-icon aria-hidden="false" class="mr-2">feedback</mat-icon>Feedback
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#" onClick="return false;">
                                                <mat-icon aria-hidden="false" class="mr-2">help</mat-icon>Help
                                            </a>
                                         </li> -->
                                        <li>
                                            <a href="javascript:void(0);" (click)="openChangePasswordModal(changePasswordModal)">
                                                <mat-icon aria-hidden="false" class="mr-2"><i class="fa fa-retweet"></i>
                                                </mat-icon>Change Password
                                            </a>
                                        </li>
                                        <li>
                                            <a href="javascript:void(0);" (click)="openHelpPdf()">
                                                <mat-icon aria-hidden="false" class="mr-2">help
                                                </mat-icon>Help
                                            </a>
                                        </li>
                                        <li>
                                            <a href="javascript:void(0);" (click)="logout()">
                                                <mat-icon aria-hidden="false" class="mr-2">power_settings_new</mat-icon>
                                                Logout
                                            </a>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </li>
                <!-- #END# Tasks -->
                <!-- <li class="pull-right">
                    <button mat-icon-button (click)="toggleRightSidebar()" class="nav-notification-icons js-right-sidebar">
                        <mat-icon id="settingBtn">settings</mat-icon>
                    </button>
                </li> -->
            </ul>
        </div>
    </div>
</nav>

<!-- bulk import of event modal start -->
<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
    <ng-template #changePasswordModal let-modal>
        <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">Change Password</h4>
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true"><i class="material-icons">close</i></span>
            </button>
        </div>

        <div class="modal-body">
            <form class="validate-form" [formGroup]="changePasswordForm" (ngSubmit)="changePassword()">
                <div class="row">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 ">
                        <mat-form-field class="example-full-width mb-3" appearance="outline">
                            <mat-label>Current Password</mat-label>
                            <input matInput formControlName="current_password" required>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 ">
                        <mat-form-field class="example-full-width mb-3" appearance="outline">
                            <mat-label>New Password</mat-label>
                            <input matInput formControlName="new_password" required>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 ">
                        <mat-form-field class="example-full-width mb-3" appearance="outline">
                            <mat-label>Confirm Password</mat-label>
                            <input matInput formControlName="confirm_password" required>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row mt-10">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 text-right">
                        <div class="example-button-row">
                            <button class="btn btn-primary" type="submit">Change Password</button>
                            <button class="btn btn-danger" type="button" (click)="modal.close()">Cancel</button>
                        </div>
                    </div>
                </div>

            </form>
        </div>
    </ng-template>
</div>